module.exports = __webpack_public_path__ + "f89cf982d10318dfd15a96e37b6f33a3.svg";